import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";

const DeletePopUp = ({ value, onValueUpdate, onButtonClicked }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleSubmit = async () => {
    onValueUpdate(false);
    onButtonClicked(checked);
    setChecked(false);
  };

  const handleClose = () => {
    onValueUpdate(false);
  };

  return (
    <Dialog open={value} onClose={handleClose}>
      <DialogTitle style={{ textAlign: "right" }}>מחיקת משתמש</DialogTitle>
      <DialogContent style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="subtitle1">למחוק בכול הלקוחות </Typography>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      </DialogContent>
      <DialogActions style={{ justifyContent: "flex-start" }}>
        <Button onClick={handleSubmit} color="primary">
          אישור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopUp;
